export default __webpack_public_path__ + "static/media/savona_fiori.4a1b6e0c.JPG";